import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import SignConsent from './SignConsent';
import { useSignConsentAPI } from './SignConsent/useSignConsentAPI';
import { selectRoomInvitationJoinData } from '../../redux/healthboard/selectors';

const InvitePatientConsent = ({ code }) => {
  const appointment = useSelector(selectRoomInvitationJoinData);

  const { loading, signConsent } = useSignConsentAPI({
    makeUrl: id => `/appointments/consents/${id}/user_consent_info`,
    payload: { invite_code: code },
  });

  return (
    <SignConsent
      appointment={appointment}
      onSign={signConsent}
      loading={loading}
    />
  );
};

InvitePatientConsent.propTypes = {
  code: PropTypes.string,
};

export default InvitePatientConsent;



// WEBPACK FOOTER //
// ./src/components/VirtualRoom/InvitePatientConsent.jsx